<script setup lang="ts">
defineOptions({ inheritAttrs: false });
defineProps<{ text?: string }>();
</script>
<template>
  <nut-radio class="mp-radio" v-bind="$attrs">
    <template #default v-if="$slots.default">
      <slot name="default" />
    </template>
    <template #default v-else-if="text">
      {{ text }}
    </template>
  </nut-radio>
</template>
